import { GUIDE_LIST_ITEM_KIND } from '../constants';

export const isChannel = ({ kind }) => kind === GUIDE_LIST_ITEM_KIND.CHANNEL;
